import { eventInterceptorMap, EventInterceptorProvider } from '@consta/uikit/EventInterceptor'
import { ErrorBoundary } from '@core/core/utils'
import { useMessenger, useSpaEventHandler, useSpaLogin } from '@core/hooks'
import { CenteredLoader, ThemeProvider } from '@library/components'
import { ModalManagerContextProvider } from '@library/model'
import messenger from 'common/messenger'
import type { FC, PropsWithChildren } from 'react'
import { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'

import css from './index.css'

export const AppContext: FC<PropsWithChildren> = ({ children }) => {
  useSpaLogin()
  const eventHandler = useSpaEventHandler()
  useMessenger(messenger)

  return (
    <EventInterceptorProvider eventHandler={eventHandler} map={eventInterceptorMap}>
      <ThemeProvider>
        <div className={css.background} />
        <ModalManagerContextProvider>
          <BrowserRouter>
            <ErrorBoundary>
              <div className={css.app}>
                <Suspense fallback={<CenteredLoader />}>{children}</Suspense>
              </div>
            </ErrorBoundary>
          </BrowserRouter>
        </ModalManagerContextProvider>
      </ThemeProvider>
    </EventInterceptorProvider>
  )
}
